module.exports = __webpack_public_path__ + "media/images/site/ellipse-left-21f7508931b05e04a1547f2e529209c7.svg";